const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');
// const DEFAULT_PAGE = () => import('@/layout/page.vue');

const PROCEEDS = {
  path: '/customer-sales',
  name: 'customer-sales',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'customer-sales-list' },
  meta: {
    title: '售后客户',
    requiresAuth: true,
    hideChildrenInMenu: true,
    // icon: 'icon-file ',
    roles: 'customer-sales',
    order: 123
  },
  children: [
    {
      path: '',
      name: 'customer-sales-list',
      component: () => import('@/views/sys-obj/sys-obj.vue'),
      props: { entity: 2 },
      meta: {
        requiresAuth: true,
        title: '售后客户'
      }
    }
  ]
};

export default PROCEEDS;
